import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./secondHeader.css";
import headerLogo from "../../../src/assets/logoJul.svg";
import menuIcon from "../../assets/dotD.svg";

// Fotoğrafçılar ve Yönetmenler Listeleri
const photographers = [
  { name: "UTKU ATALAY", path: "/photographers/utku-atalay" },
  { name: "CAN ÇİÇEK", path: "/photographers/can-cicek" },
  { name: "MUSTAFA ÇETİN", path: "/photographers/mustafa-cetin" },
  { name: "ŞENOL ALTUN", path: "/photographers/senol-altun" },
  { name: "FETHİ KARADUMAN", path: "/photographers/fethi-karaduman" },
  { name: "SİNEM YAZICI", path: "/photographers/sinem-yazici" },
  { name: "ONUR AYNAGÖZ", path: "/photographers/onur-aynagoz" },
  { name: "EKİN CAN BAYRAKDAR", path: "/photographers/ekin-can-bayrakdar" },
];


const directors = [
  { name: "ÇAĞRI ARK", path: "/directors/cagri-ark" },
  { name: "ÇAĞ ÇALIŞKUR", path: "/directors/cag-caliskur" },
  { name: "VOLKAN İÇYILMAZ", path: "/directors/volkan-icyilmaz" },
  { name: "UTKU ATALAY", path: "/directors/utku-atalay" },
];

const SecondHeader = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Hamburger menü aç/kapa

  const navigate = useNavigate();
  const location = useLocation();

  // Ref'ler
  const searchBoxRef = useRef(null);
  const menuIconRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // Sayfa dışına tıklayınca SearchBox ve menüyü kapat
  useEffect(() => {
    function handleClickOutside(event) {
      // 1) Arama kutusunu kapat
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
        setSearchTerm("");
        setSelectedIndex(-1);
      }
      // 2) Hamburger menü dışına tıklayınca kapat
      if (isMenuOpen) {
        if (
          mobileMenuRef.current &&
          !mobileMenuRef.current.contains(event.target) &&
          menuIconRef.current &&
          !menuIconRef.current.contains(event.target)
        ) {
          setIsMenuOpen(false);
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  // Hover durumu
  const handleMouseEnter = (item) => setHoveredItem(item);
  const handleMouseLeave = () => setHoveredItem(null);

  // Menü item’larında aktif sayfa vs.
  const getClassName = (item) => {
    if (location.pathname.includes(item.toLowerCase())) {
      return "menu-item-secondHeader filled";
    }
    return hoveredItem === item
      ? "menu-item-secondHeader filled"
      : "menu-item-secondHeader outlined";
  };

  // Arama Filtre
  const filteredResults = [...photographers, ...directors].filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Arama Seçimi
  const handleSelect = (path) => {
    setSearchTerm("");
    setIsSearchOpen(false);
    setSelectedIndex(-1);
    navigate(path);
  };

  // Arama Enter / Ok tuşları
  const handleKeyDown = (e) => {
    if (filteredResults.length === 0) return;

    if (e.key === "ArrowDown") {
      setSelectedIndex((prev) =>
        prev < filteredResults.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prev) =>
        prev > 0 ? prev - 1 : filteredResults.length - 1
      );
    } else if (e.key === "Enter" && selectedIndex >= 0) {
      handleSelect(filteredResults[selectedIndex].path);
    }
  };

  return (
    <div className="second-header fade-slide-in">
      {/* Sütun 1: Search Container */}
      <div className="search-container" ref={searchBoxRef}>
        <div
          className={`search-dot ${isSearchOpen ? "expanded" : ""}`}
          onClick={() => setIsSearchOpen(true)}
        >
          {isSearchOpen && (
            <input
              type="text"
              className="search-box"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          )}
        </div>

        {/* Arama Sonuçları */}
        {isSearchOpen && searchTerm && (
          <ul className="search-results">
            {filteredResults.map((result, index) => (
              <li
                key={index}
                onClick={() => handleSelect(result.path)}
                className={index === selectedIndex ? "selected" : ""}
              >
                {result.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Sütun 2-3: Photographers, Directors */}
      <Link
        to="/photographers"
        className={`${getClassName("photographers")} photographers-link`}
        onMouseEnter={() => handleMouseEnter("photographers")}
        onMouseLeave={handleMouseLeave}
      >
        PHOTOGRAPHERS
      </Link>
      <Link
        to="/directors"
        className={`${getClassName("directors")} directors-link`}
        onMouseEnter={() => handleMouseEnter("directors")}
        onMouseLeave={handleMouseLeave}
      >
        DIRECTORS
      </Link>

      {/* Sütun 4: Logo */}
      <Link to="/jul" className="header-logo-link">
        <img src={headerLogo} alt="Header Logo" className="header-logo" />
      </Link>

      {/* Sütun 5-6: About, Contact */}
      <Link
        to="/about"
        className={`${getClassName("about")} about-link`}
        onMouseEnter={() => handleMouseEnter("about")}
        onMouseLeave={handleMouseLeave}
      >
        ABOUT
      </Link>
      <Link
        to="/contact"
        className={`${getClassName("contact")} contact-link`}
        onMouseEnter={() => handleMouseEnter("contact")}
        onMouseLeave={handleMouseLeave}
      >
        CONTACT
      </Link>

      {/* Sütun 7: Menü İkonu (Desktop'ta pasif, mobil/tablette tıklanabilir) */}
      <div
        className="menu-icon-container"
        ref={menuIconRef}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <img src={menuIcon} alt="Menu Icon" className="menu-icon" />
      </div>

      {/* Hamburger Menü (Mobil/Tablet) */}
      {isMenuOpen && (
          <div 
          className="mobile-menu" 
          ref={mobileMenuRef}
          
        >
          <Link
            to="/jul"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            JUL
          </Link>
          <Link
            to="/home"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            HOME
          </Link>
          <Link
            to="/photographers"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            PHOTOGRAPHERS
          </Link>
          <Link
            to="/directors"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            DIRECTORS
          </Link>
          <Link
            to="/about"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            ABOUT
          </Link>
          <Link
            to="/contact"
            onClick={() => setIsMenuOpen(false)}
            className="mobile-menu-link"
          >
            CONTACT
          </Link>
        </div>
      )}
    </div>
  );
};

export default SecondHeader;
